module.exports = __webpack_public_path__ + "static/media/harris.dca1de86.jpg";